export function getScoreBarColorClass(score: number): string {
  if (score >= 80) return 'bg-green-500';
  if (score >= 60) return 'bg-lime-500';
  if (score >= 40) return 'bg-yellow-400';
  if (score >= 20) return 'bg-orange-500';
  return 'bg-red-500';
}
